/**
 * El shell de la app (App.vue) envuelve cada ruta -incluidas las landings
 * públicas- en varios contenedores con overflow-y:auto anidados
 * (.AppMain__layer__PageAndTopBar, .Scrollable--vertical). Por eso el
 * verdadero scroll casi nunca ocurre en `window`/`document.body`, y hay que
 * ubicar el/los ancestros que realmente scrollean en lugar de asumir cuál es.
 */
export function getScrollAncestors(el: HTMLElement | null): (HTMLElement | Window)[] {
  const targets: (HTMLElement | Window)[] = [window];
  let node = el?.parentElement ?? null;

  while (node && node !== document.body && node !== document.documentElement) {
    targets.push(node);
    node = node.parentElement;
  }

  return targets;
}

export function scrollAncestorsToTop(el: HTMLElement | null, smooth = true) {
  getScrollAncestors(el).forEach((target) => {
    const options: ScrollToOptions = {
      top: 0,
      behavior: smooth ? 'smooth' : 'auto',
    };
    if (target === window) {
      window.scrollTo(options);
    } else {
      (target as HTMLElement).scrollTo(options);
    }
  });
}
